import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

export type AdminLanguage = 'ro' | 'en';

@Injectable()
export class TranslationService {
    readonly languageChanged = new BehaviorSubject<AdminLanguage>('ro');
    private currentLanguage: AdminLanguage = 'ro';
    private readonly romanian: { [key: string]: string } = {
        'Admin panel': 'Panou de administrare',
        'Romanian': 'Română',
        'English': 'Engleză',
        'Language': 'Limbă',
        'Overview': 'Prezentare generală',
        'Cars': 'Mașini',
        'cars': 'mașini',
        'Map': 'Hartă',
        'Live map': 'Hartă live',
        'Orders': 'Comenzi',
        'POS Terminals': 'Terminale POS',
        'POS terminals': 'Terminale POS',
        'Vouchers': 'Vouchere',
        'Airport Cars': 'Mașini aeroport',
        'Airport cars': 'Mașini aeroport',
        'Airport Kiosk': 'Kiosk aeroport',
        'Airport kiosk': 'Kiosk aeroport',
        'Profile': 'Profil',
        'Refresh': 'Actualizează',
        'Showing': 'Se afișează',
        'of': 'din',
        'Search': 'Caută',
        'Reset': 'Resetează',
        'Save': 'Salvează',
        'Cancel': 'Anulează',
        'Close': 'Închide',
        'Details': 'Detalii',
        'Edit': 'Editează',
        'Yes': 'Da',
        'No': 'Nu',
        'YES': 'DA',
        'NO': 'NU',
        'All': 'Toate',
        'Rows': 'Rânduri',
        'Date': 'Dată',
        'Created': 'Creată',
        'Client': 'Client',
        'Client name': 'Nume client',
        'Phone': 'Telefon',
        'Email': 'E-mail',
        'Name': 'Nume',
        'Address': 'Adresă',
        'Comments': 'Comentarii',
        'Status': 'Stare',
        'Source': 'Sursă',
        'Price': 'Preț',
        'Amount': 'Sumă',
        'Distance': 'Distanță',
        'Payment': 'Plată',
        'Payment method': 'Metodă de plată',
        'Cash': 'Numerar',
        'Card': 'Card',
        'Voucher': 'Voucher',
        'Order': 'Comandă',
        'Car': 'Mașină',
        'Car ID': 'Indicativ',
        'Car number': 'Număr mașină',
        'Car Number': 'Număr mașină',
        'Car Model': 'Model mașină',
        'City': 'Oraș',
        'Company': 'Companie',
        'Driver': 'Șofer',
        'Drivers': 'Șoferi',
        'Driver phone': 'Telefon șofer',
        'Last login': 'Ultima conectare',
        'Last Login': 'Ultima conectare',
        'Suspended': 'Suspendată',
        'Suspension': 'Suspendare',
        'Services': 'Servicii',
        'Vehicle': 'Vehicul',
        'Authorization': 'Autorizație',
        'Pairing': 'Asociere',
        'Paired': 'Asociat',
        'Ready to pair': 'Pregătit pentru asociere',
        'Unpair': 'Dezasociază',
        'Unpair device': 'Dezasociază dispozitivul',
        'Package': 'Pachet',
        'Route': 'Traseu',
        'Pickup': 'Preluare',
        'Destination': 'Destinație',
        'Stops': 'Opriri',
        'Platform': 'Platformă',
        'Summary': 'Rezumat',
        'Started': 'Pornită',
        'Finished at': 'Finalizată la',
        'Assigned car': 'Mașină alocată',
        'Customer': 'Client',
        'Photo': 'Fotografie',
        'Voucher ID': 'ID voucher',
        'Voucher IDs': 'ID-uri voucher',
        'Voucher amount': 'Valoare voucher',
        'Terminal ID': 'ID terminal',
        'Installation date': 'Data instalării',
        'Last order': 'Ultima comandă',
        'Total orders': 'Total comenzi',
        'Pairing code': 'Cod de asociere',
        'Latitude': 'Latitudine',
        'Longitude': 'Longitudine',
        'Receipt header': 'Antet bon',
        'Receipt footer': 'Subsol bon',
        'In production': 'În producție',
        'Max cars count': 'Număr maxim de mașini',
        'Allow car selection': 'Permite selectarea mașinii',
        'Allow street service': 'Permite serviciul stradal',
        'POS application': 'Aplicație POS',
        'POS version': 'Versiune POS',
        'Device-specific version': 'Versiune specifică dispozitivului',
        'Save POS Version': 'Salvează versiunea POS',
        'Add POS Version': 'Adaugă versiunea POS',
        'Reset pairing code': 'Resetează codul de asociere',
        'Manage account': 'Administrare cont',
        'Account details': 'Detalii cont',
        'Username': 'Utilizator',
        'Current password': 'Parola curentă',
        'New password': 'Parola nouă',
        'Confirm new password': 'Confirmă parola nouă',
        'Save profile': 'Salvează profilul',
        'Log in': 'Autentificare',
        'Password': 'Parolă',
        'Sign In': 'Autentificare',
        'Username or password are incorrect.': 'Utilizatorul sau parola sunt incorecte.',
        'Update your account details and password.': 'Actualizează detaliile contului și parola.',
        'Your username identifies the account and cannot be changed.': 'Numele de utilizator identifică acest cont și nu poate fi schimbat.',
        'Change password': 'Schimbă parola',
        'Leave these fields empty to keep your current password.': 'Lasă aceste câmpuri necompletate pentru a păstra parola curentă.',
        'Verify new password': 'Confirmă parola nouă',
        'Saving...': 'Se salvează...',
        'Save changes': 'Salvează modificările',
        'View the current airport queue and select a car to inspect its details.': 'Vezi coada curentă de la aeroport și selectează o mașină pentru detalii.',
        'Currently there are no cars in the airport queue.': 'Momentan nu există mașini în coada de la aeroport.',
        'Manage the airport kiosk and inspect its latest system logs.': 'Administrează kiosk-ul aeroportului și verifică ultimele loguri de sistem.',
        'Menu': 'Meniu',
        'Username...': 'Utilizator...',
        'Password...': 'Parolă...',
        'Loading...': 'Se încarcă...',
        'Loading cars...': 'Se încarcă mașinile...',
        'Select a car to inspect status, driver assignments, pairing and service settings.': 'Selectează o mașină pentru a verifica starea, șoferii, asocierea și serviciile.',
        'Export all data': 'Exportă toate datele',
        'Search cars': 'Caută mașini',
        'Search by car ID, number, app version or driver': 'Caută după indicativ, număr, versiunea aplicației sau șofer',
        'No cars match the current search or filters.': 'Nicio mașină nu corespunde căutării sau filtrelor curente.',
        'Loading orders...': 'Se încarcă comenzile...',
        'Browse all completed orders and inspect their full route and details.': 'Răsfoiește toate comenzile și verifică traseul și detaliile complete.',
        'Client phone number': 'Număr de telefon client',
        'Search by client phone number': 'Caută după numărul de telefon al clientului',
        'Clear order filters': 'Șterge filtrele comenzilor',
        'Car ID or number': 'Indicativ sau număr mașină',
        'Server timeout': 'Timeout server',
        'Assigned': 'Alocată',
        'Approaching': 'Se apropie',
        'Arrived': 'A sosit',
        'Client picked': 'Client preluat',
        'On the way': 'În cursă',
        'Finished': 'Finalizată',
        'Canceled by customer': 'Anulată de client',
        'Canceled by driver': 'Anulată de șofer',
        'Try again': 'Încearcă din nou',
        'No orders match these filters.': 'Nicio comandă nu corespunde acestor filtre.',
        'No orders were found.': 'Nu au fost găsite comenzi.',
        'Clear filters': 'Șterge filtrele',
        'Orders pages': 'Paginile comenzilor',
        'Loading vouchers...': 'Se încarcă voucherele...',
        'Loading POS terminals...': 'Se încarcă terminalele POS...',
        'never': 'niciodată',
        'Never': 'Niciodată',
        'All cities': 'Toate orașele',
        'All companies': 'Toate companiile',
        'All cars': 'Toate mașinile',
        'All clients': 'Toți clienții',
        'All statuses': 'Toate stările',
        'All sources': 'Toate sursele',
        'All payment methods': 'Toate metodele de plată',
        'created': 'creată',
        'timeout': 'timeout server',
        'assigned': 'alocată',
        'approaching': 'se apropie',
        'arrived': 'a sosit',
        'clientPicked': 'client preluat',
        'onTheWay': 'în cursă',
        'finished': 'finalizată',
        'clientCanceled': 'anulată de client',
        'driverCanceled': 'anulată de șofer',
        'Dispatch': 'Dispecerat',
        'Street Order': 'Comandă stradală',
        'Airport': 'Aeroport',
        'Manual': 'Manual',
        'Caller': 'Apelant',
        'Unknown': 'Necunoscut',
        'Today orders': 'Comenzile de astăzi',
        'Total orders by platform': 'Total comenzi după platformă',
        'Orders by payment method': 'Comenzi după metoda de plată',
        'Today orders by payment method': 'Comenzile de astăzi după metoda de plată',
        'Recent kiosk logs': 'Loguri recente kiosk',
        'SSH Logs': 'Loguri SSH',
        'Restart Kiosk': 'Repornește kiosk-ul',
        'Restarting...': 'Se repornește...',
        'Airport queue': 'Coadă aeroport',
        'Open menu': 'Deschide meniul',
        'Close menu': 'Închide meniul',
        'Open profile': 'Deschide profilul',
        'My profile': 'Profilul meu',
        'My Profile': 'Profilul meu',
        'Log out': 'Deconectare',
        'Previous page': 'Pagina anterioară',
        'Next page': 'Pagina următoare',
        'Open car details': 'Deschide detaliile mașinii',
        'Open order details': 'Deschide detaliile comenzii',
        'Loading active order...': 'Se încarcă comanda activă...',
        'Active order unavailable.': 'Comanda activă nu este disponibilă.',
        'Close car details': 'Închide detaliile mașinii',
        'Close order details': 'Închide detaliile comenzii'
        ,
        'Order details': 'Detalii comandă'
        ,
        'Closed': 'Închisă'
        ,
        'Accepted': 'Acceptată'
        ,
        'First proposal': 'Prima propunere'
        ,
        'Billable time': 'Timp facturabil'
        ,
        'Service type': 'Tip serviciu'
        ,
        'Destination type': 'Tip destinație'
        ,
        'Client and request': 'Client și solicitare'
        ,
        'App version': 'Versiune aplicație'
        ,
        'Device ID': 'ID dispozitiv'
        ,
        'External order ID': 'ID comandă externă'
        ,
        'Airport order': 'Comandă aeroport'
        ,
        'Phone order': 'Comandă telefonică'
        ,
        'Office order': 'Comandă de birou'
        ,
        'Car and driver': 'Mașină și șofer'
        ,
        'Car identifier': 'Identificator mașină'
        ,
        'Model': 'Model'
        ,
        'Driver ID': 'ID șofer'
        ,
        'Loading recorded route': 'Se încarcă traseul înregistrat'
        ,
        'recorded points': 'puncte înregistrate'
        ,
        'interactive': 'interactive'
        ,
        'No recorded route': 'Nu există traseu înregistrat'
        ,
        'Speed': 'Viteză'
        ,
        'No route coordinates are stored for this order.': 'Nu există coordonate de traseu salvate pentru această comandă.'
        ,
        'Manage terminal details, receipts, service options and device pairing.': 'Administrează detaliile terminalelor, bonurile, serviciile și asocierea dispozitivelor.'
        ,
        'Search terminals': 'Caută terminale'
        ,
        'Search by client, terminal, address or phone': 'Caută după client, terminal, adresă sau telefon'
        ,
        'Edit POS': 'Editează POS'
        ,
        'No POS terminals were found.': 'Nu au fost găsite terminale POS.'
        ,
        'No POS terminals match this search.': 'Niciun terminal POS nu corespunde căutării.'
        ,
        'terminals': 'terminale'
        ,
        'POS terminal': 'Terminal POS'
        ,
        'POS settings': 'Setări POS'
        ,
        'Close POS settings': 'Închide setările POS'
        ,
        'Device pairing': 'Asociere dispozitiv'
        ,
        'Waiting for device': 'Se așteaptă dispozitivul'
        ,
        'Generating...': 'Se generează...'
        ,
        'Loading POS version...': 'Se încarcă versiunea POS...'
        ,
        'No device-specific version exists. Version': 'Nu există o versiune specifică dispozitivului. Versiunea'
        ,
        'will be added.': 'va fi adăugată.'
        ,
        'Terminal details': 'Detalii terminal'
        ,
        'Receipt': 'Bon fiscal'
        ,
        'Service settings': 'Setări servicii'
        ,
        'Maximum cars': 'Număr maxim de mașini'
        ,
        'Production environment': 'Mediu de producție'
        ,
        'Terminal location': 'Locația terminalului'
        ,
        'Drag the marker to update the coordinates.': 'Trage marcatorul pentru a actualiza coordonatele.'
        ,
        'Pending voucher payments waiting for review.': 'Plăți cu voucher în așteptare pentru verificare.'
        ,
        'Search vouchers': 'Caută vouchere'
        ,
        'Search by client name, voucher ID or amount': 'Caută după numele clientului, ID-ul voucherului sau sumă'
        ,
        'No pending vouchers.': 'Nu există vouchere în așteptare.'
        ,
        'No vouchers match the current search or filters.': 'Niciun voucher nu corespunde căutării sau filtrelor curente.'
        ,
        'vouchers': 'vouchere'
        ,
        'Voucher details': 'Detalii voucher'
        ,
        'Paying...': 'Se plătește...'
        ,
        'Pay voucher': 'Plătește voucherul'
        ,
        'Zoom out': 'Micșorează'
        ,
        'Reset zoom': 'Resetează zoom-ul'
        ,
        'Zoom in': 'Mărește'
        ,
        'Voucher photo': 'Fotografie voucher'
        ,
        'No photo attached.': 'Nu este atașată nicio fotografie.'
        ,
        'Call driver': 'Sună șoferul'
        ,
        'No route coordinates available.': 'Nu sunt disponibile coordonate pentru traseu.'
        ,
        'Monitor fleet availability and order activity.': 'Monitorizează disponibilitatea flotei și activitatea comenzilor.'
        ,
        'Total Cars': 'Total mașini'
        ,
        'Total Drivers': 'Total șoferi'
        ,
        'Suspended Cars': 'Mașini suspendate'
        ,
        'Online Cars': 'Mașini online'
        ,
        'Available Cars': 'Mașini disponibile'
        ,
        'Daily orders grouped by source for the last 7 days.': 'Comenzi zilnice grupate după sursă pentru ultimele 7 zile.'
        ,
        'total': 'total'
        ,
        'No orders found in the last 7 days.': 'Nu au fost găsite comenzi în ultimele 7 zile.'
        ,
        'Orders grouped by platform for the current day.': 'Comenzi grupate după platformă pentru ziua curentă.'
        ,
        'No orders found for today.': 'Nu au fost găsite comenzi pentru astăzi.'
        ,
        'Daily orders grouped by cash, card and voucher for the last 7 days.': 'Comenzi zilnice grupate după numerar, card și voucher pentru ultimele 7 zile.'
        ,
        'No payment data found in the last 7 days.': 'Nu au fost găsite date de plată în ultimele 7 zile.'
        ,
        'Total': 'Total'
        ,
        'orders': 'comenzi'
        ,
        'Current-day orders grouped by payment method.': 'Comenzile zilei curente grupate după metoda de plată.'
        ,
        'No payment data found for today.': 'Nu au fost găsite date de plată pentru astăzi.'
        ,
        'cash': 'numerar'
        ,
        'card': 'card'
        ,
        'voucher': 'voucher'
        ,
        'Locate active cars and focus the map on a selected car.': 'Localizează mașinile active și centrează harta pe mașina selectată.'
        ,
        'Search and select a car ID': 'Caută și selectează un indicativ'
        ,
        'Search car ID': 'Caută indicativ'
        ,
        'Toggle Car ID options': 'Afișează opțiunile pentru indicative'
        ,
        'No matching Car IDs': 'Nu există indicative potrivite'
        ,
        'Driver details': 'Detalii șofer'
        ,
        'Review the driver profile and the orders assigned to the current car.': 'Verifică profilul șoferului și comenzile alocate mașinii curente.'
        ,
        'Select a driver to view orders.': 'Selectează un șofer pentru a vedea comenzile.'
        ,
        'Orders filtered by car': 'Comenzi filtrate după mașină'
        ,
        'No orders were found for this car.': 'Nu au fost găsite comenzi pentru această mașină.'
        ,
        'Driver order pages': 'Paginile comenzilor șoferului'
        ,
        'Car Details': 'Detalii mașină'
        ,
        'The canunpairdevice permission is required': 'Este necesară permisiunea canunpairdevice'
        ,
        'Select package': 'Selectează pachetul'
        ,
        'Until': 'Până la'
        ,
        'Suspend': 'Suspendă'
        ,
        'Unsuspend': 'Reactivează'
        ,
        'Confirm Action': 'Confirmă acțiunea'
        ,
        'Reason': 'Motiv'
        ,
        'Permanent': 'Permanent'
        ,
        'Price per km': 'Preț per km'
        ,
        'Standard': 'Standard'
        ,
        'Premium': 'Premium'
        ,
        'Are you sure you want to unpair this device?': 'Sigur dorești să dezasociezi acest dispozitiv?'
        ,
        'Are you sure you want to enable drink safe?': 'Sigur dorești să activezi Drink Safe?'
        ,
        'Alege pachet': 'Selectează pachetul'
        ,
        'Submit': 'Trimite'
        ,
        'Are you sure you want to suspend this driver?': 'Sigur dorești să suspenzi acest șofer?'
        ,
        'Are you sure you want to unsuspend this driver?': 'Sigur dorești să reactivezi acest șofer?'
        ,
        'Unpair was cancelled': 'Dezasocierea a fost anulată'
        ,
        'Unpair was completed with success': 'Dezasocierea a fost finalizată cu succes'
        ,
        'Failed to make the unpair': 'Dezasocierea nu a reușit'
        ,
        'You are about to restart the kiosk. This is a dangerous action. Are you sure you want to continue?': 'Kiosk-ul va fi repornit. Aceasta este o acțiune periculoasă. Sigur dorești să continui?'
        ,
        'Enter a name and a valid email address.': 'Introdu un nume și o adresă de e-mail validă.'
        ,
        'A name and a valid email address are required.': 'Numele și o adresă de e-mail validă sunt obligatorii.'
        ,
        'Current password, new password and password confirmation are required.': 'Parola curentă, parola nouă și confirmarea parolei sunt obligatorii.'
        ,
        'Complete all three password fields to change your password.': 'Completează toate cele trei câmpuri pentru a schimba parola.'
        ,
        'The new passwords do not match.': 'Parolele noi nu coincid.'
        ,
        'The profile could not be updated.': 'Profilul nu a putut fi actualizat.'
        ,
        'Profile updated successfully.': 'Profilul a fost actualizat cu succes.'
        ,
        'The current password is incorrect.': 'Parola curentă este incorectă.'
        ,
        'The admin user was not found.': 'Utilizatorul administrator nu a fost găsit.'
        ,
        'The orders could not be loaded. Please try again.': 'Comenzile nu au putut fi încărcate. Încearcă din nou.'
        ,
        'The driver could not be loaded.': 'Șoferul nu a putut fi încărcat.'
        ,
        'The orders for this car could not be loaded.': 'Comenzile acestei mașini nu au putut fi încărcate.'
        ,
        'The POS terminals could not be loaded.': 'Terminalele POS nu au putut fi încărcate.'
        ,
        'The POS terminals could not be loaded. Please try again.': 'Terminalele POS nu au putut fi încărcate. Încearcă din nou.'
        ,
        'The POS could not be saved.': 'Terminalul POS nu a putut fi salvat.'
        ,
        'POS settings saved successfully.': 'Setările POS au fost salvate cu succes.'
        ,
        'The pairing code could not be reset.': 'Codul de asociere nu a putut fi resetat.'
        ,
        'A new pairing code was generated.': 'A fost generat un cod de asociere nou.'
        ,
        'A terminal ID is required to load the POS version.': 'Este necesar ID-ul terminalului pentru încărcarea versiunii POS.'
        ,
        'The POS app version could not be loaded.': 'Versiunea aplicației POS nu a putut fi încărcată.'
        ,
        'The POS app version could not be saved.': 'Versiunea aplicației POS nu a putut fi salvată.'
        ,
        'POS app version saved successfully.': 'Versiunea aplicației POS a fost salvată cu succes.'
        ,
        'Terminal ID is required.': 'ID-ul terminalului este obligatoriu.'
        ,
        'Latitude must be between -90 and 90.': 'Latitudinea trebuie să fie între -90 și 90.'
        ,
        'Longitude must be between -180 and 180.': 'Longitudinea trebuie să fie între -180 și 180.'
        ,
        'Maximum cars count must be a positive whole number or zero.': 'Numărul maxim de mașini trebuie să fie un număr întreg pozitiv sau zero.'
        ,
        'Adding...': 'Se adaugă...'
        ,
        'Failed to pay voucher.': 'Plata voucherului nu a reușit.'
        ,
        'Loading recent logs...': 'Se încarcă logurile recente...'
        ,
        'Could not load recent logs.': 'Logurile recente nu au putut fi încărcate.'
        ,
        'No log output.': 'Nu există conținut în log.'
        ,
        'Failed': 'Eșuat'
        ,
        'Your session has expired. Please sign in again.': 'Sesiunea a expirat. Autentifică-te din nou.'
        ,
        'Airport Kiosk request failed.': 'Solicitarea către kiosk-ul aeroportului a eșuat.'
        ,
        'Total orders by platform for the last seven days': 'Total comenzi după platformă pentru ultimele șapte zile'
        ,
        'Orders by payment method for the last seven days': 'Comenzi după metoda de plată pentru ultimele șapte zile'
        ,
        'orders today': 'comenzi astăzi'
    };

    get language(): AdminLanguage {
        return this.currentLanguage;
    }

    setLanguage(language: any) {
        const normalized: AdminLanguage = String(language || '').trim().toLowerCase() === 'en' ? 'en' : 'ro';
        this.currentLanguage = normalized;
        document.documentElement.lang = normalized;
        this.languageChanged.next(normalized);
    }

    translate(value: any): string {
        if (value === undefined || value === null) {
            return '';
        }

        const text = String(value);
        if (this.currentLanguage === 'en') {
            return text;
        }

        const invisibleCar = /^Car (.+) is not currently visible on the map\.$/.exec(text);
        if (invisibleCar) {
            return 'Mașina ' + invisibleCar[1] + ' nu este vizibilă momentan pe hartă.';
        }

        const failedAt = /^Failed at (.+)$/.exec(text);
        if (failedAt) {
            return 'Eșuat la ' + failedAt[1];
        }

        const updatedAt = /^Updated (.+)$/.exec(text);
        if (updatedAt) {
            return 'Actualizat la ' + updatedAt[1];
        }

        const kioskAction = /^Restart kiosk (started\.\.\.|failed\.|completed\.)$/.exec(text);
        if (kioskAction) {
            const actionState = kioskAction[1] === 'started...'
                ? 'a început...'
                : kioskAction[1] === 'failed.' ? 'a eșuat.' : 's-a încheiat.';
            return 'Repornirea kiosk-ului ' + actionState;
        }

        const kioskApiStatus = /^Airport Kiosk API returned (\d+)\.$/.exec(text);
        if (kioskApiStatus) {
            return 'API-ul kiosk-ului aeroportului a returnat codul ' + kioskApiStatus[1] + '.';
        }

        return this.romanian[text] || text;
    }
}
